import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { UPDATE_SMART_CODES_MUTATION } from './useUpdateSmartCodes.graphql';
import {
  IUpdateSmartCodesMutationGraphQLResponse,
  IUpdateSmartCodesMutationVariables,
  IHandleUpdateSmartCodesParams,
  IUseUpdateSmartCodesOptions,
  IUseUpdateSmartCodes,
} from './useUpdateSmartCodes.interfaces';

const useUpdateSmartCodes = (options?: IUseUpdateSmartCodesOptions): IUseUpdateSmartCodes => {
  const { mutation, onCompleted, onError, tokens } = options ?? ({} as IUseUpdateSmartCodesOptions);

  const [executeUpdateSmartCodes, { loading: isLoading }] = useLoggedGeladaMutation<
    IUpdateSmartCodesMutationGraphQLResponse,
    IUpdateSmartCodesMutationVariables
  >({
    mutation: mutation ?? UPDATE_SMART_CODES_MUTATION,
    options: {
      onCompleted: ({ smartCode: { updateSmartCodes: isCompleted } }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    tokens,
  });

  const handleUpdateSmartCodes = async ({ smartCodes }: IHandleUpdateSmartCodesParams) => {
    await executeUpdateSmartCodes({
      variables: {
        smartCodes,
      },
    });
  };

  return {
    handleUpdateSmartCodes,
    isLoading,
  };
};

export { useUpdateSmartCodes };
